import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  colors,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import SuccessIcon from "@material-ui/icons/CheckCircleOutline";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: colors.green[900],
  },
  actions: {
    backgroundColor: colors.green[900],
  },
  button: {
    color: "white",
  },
}));

const Success = ({ message, onClose = () => {} }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Box>
            <SuccessIcon fontSize="large" className={classes.icon} />
          </Box>
          <Box mt={1}>
            <Typography variant="h3">{t("register.success.title")}</Typography>
          </Box>
          <Box mt={1}>
            <Typography variant="body2">{message}</Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={1}
        >
          <Button fullWidth className={classes.button} onClick={handleClose}>
            Ok
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default Success;
